.container {
  padding: 12px 62px;
  pointer-events: none;
  background-color: var(--color-primary-blue-900);
}

.inner {
  display: grid;
  gap: 12px;
  width: 1126px;
  margin-inline: auto;
}

.top {
  display: flex;
  justify-content: space-between;
}

.left {
  display: flex;
  gap: 12px;
  align-items: center;
}

.titleText {
  font-size: 12px;
  line-height: 1.2;
  color: #bfc9d7;
}

.right {
  display: flex;
  gap: 20px;
  align-items: center;
  font-size: 14px;
  color: #fff;

  span:last-child {
    margin-right: 10px;
  }
}

.bottom {
  font-size: 14px;
  color: #bfc9d7;
}

.bottomItem {
  &:not(:last-child)::after {
    margin-inline: 8px;
    content: '|';
  }
}
